export default {
  buttons: {
    change_plan: 'Zmień plan',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
  },
};
